import { cx } from '../classname.js';

var getInteractiveState = function getInteractiveState(_ref) {
  var type = _ref.type,
    within = _ref.within,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'generic' : _ref$intent;
  var interactiveStateStyle = 'interactive-style';
  var interactiveWithin = within ? 'interactive-within' : undefined;
  var interactiveStateColor = "interactive-".concat(intent);
  var interactiveStateBg = type === 'filled' ? 'interactive-bg' : undefined;
  var interactiveStateBorder = 'interactive-border';
  var classNames = [interactiveStateStyle, interactiveStateColor, interactiveWithin, interactiveStateBorder, interactiveStateBg];
  var boxProps = {
    adsClass: classNames
  };
  var adsStyles = {
    className: cx(classNames)
  };
  return {
    boxProps: boxProps,
    adsStyles: adsStyles
  };
};

export { getInteractiveState };
//# sourceMappingURL=getInteractiveState.js.map
